export const examBanks = [
    // Exam Sample 1
    [
        { id: 1, type: 'tf', question: 'The Bible was written by approximately 40 different authors over a period of about 1,500 years.', answer: true },
        { id: 2, type: 'tf', question: 'The Sabbath was created at Mount Sinai when the Ten Commandments were given.', answer: false },
        { id: 3, type: 'tf', question: 'The scapegoat in Leviticus 16 represents Jesus Christ.', answer: false },
        { id: 4, type: 'mc', question: 'How many books are in the Bible?', options: ['39', '66', '73', '27'], answer: 1 },
        { id: 5, type: 'mc', question: 'When did the 2300-day prophecy of Daniel 8:14 end?', options: ['1798 AD', '1833 AD', '1844 AD', '1863 AD'], answer: 2 },
        { id: 6, type: 'tf', question: 'Justification is the work of Christ FOR us, while sanctification is the work of Christ IN us.', answer: true },
        { id: 7, type: 'mc', question: 'According to 1 Timothy 2:5, who is the only mediator between God and man?', options: ['Mary', 'Jesus Christ', 'The Holy Spirit', 'Angels'], answer: 1 },
        { id: 8, type: 'tf', question: 'The dead are conscious and aware in heaven or hell immediately after death.', answer: false },
        { id: 9, type: 'mc', question: 'What year did the 1260-year papal supremacy period end?', options: ['1755 AD', '1780 AD', '1798 AD', '1844 AD'], answer: 2 },
        { id: 10, type: 'tf', question: 'Jesus will return to earth visibly, audibly, and gloriously.', answer: true },
    ],
    // Exam Sample 2
    [
        { id: 1, type: 'tf', question: 'The Holy Spirit is an impersonal force, not a divine person.', answer: false },
        { id: 2, type: 'mc', question: 'On what day did God rest after Creation?', options: ['First day', 'Sixth day', 'Seventh day', 'Any day'], answer: 2 },
        { id: 3, type: 'tf', question: 'The Great Controversy theme explains the origin of sin and God\'s plan to end it.', answer: true },
        { id: 4, type: 'mc', question: 'What does Ecclesiastes 9:5 say about the dead?', options: ['They know everything', 'They know nothing', 'They know some things', 'They become angels'], answer: 1 },
        { id: 5, type: 'tf', question: 'Baptism in the New Testament was performed by sprinkling or pouring water.', answer: false },
        { id: 6, type: 'mc', question: 'Which date marks the Lisbon earthquake prophesied as a sign of the Second Coming?', options: ['1755 AD', '1780 AD', '1833 AD', '1844 AD'], answer: 0 },
        { id: 7, type: 'tf', question: 'The Sabbath will be kept in the new earth according to Isaiah 66:22-23.', answer: true },
        { id: 8, type: 'mc', question: 'What are the three phases of judgment?', options: ['Past, Present, Future', 'Investigative, Executive, Millennial', 'Earthly, Heavenly, Eternal', 'Individual, National, Universal'], answer: 1 },
        { id: 9, type: 'tf', question: 'According to Revelation 12:17, the remnant church keeps God\'s commandments and has the testimony of Jesus.', answer: true },
        { id: 10, type: 'mc', question: 'When did Jesus begin His ministry in the Most Holy Place of the heavenly sanctuary?', options: ['31 AD', '70 AD', '1798 AD', '1844 AD'], answer: 3 },
    ],
    // Exam Sample 3
    [
        { id: 1, type: 'mc', question: 'How many languages were the original Bible manuscripts written in?', options: ['One', 'Two', 'Three', 'Four'], answer: 2 },
        { id: 2, type: 'tf', question: 'God is eternal, omnipresent, omniscient, and omnipotent.', answer: true },
        { id: 3, type: 'mc', question: 'What does Ezekiel 20:12 say the Sabbath is a sign of?', options: ['Creation', 'Sanctification', 'Redemption', 'All of these'], answer: 3 },
        { id: 4, type: 'tf', question: 'Sin originated with Adam and Eve in the Garden of Eden.', answer: false },
        { id: 5, type: 'mc', question: 'According to Romans 6:23, what is the wages of sin?', options: ['Sickness', 'Death', 'Poverty', 'Suffering'], answer: 1 },
        { id: 6, type: 'tf', question: 'Jesus Christ is both fully divine and fully human.', answer: true },
        { id: 7, type: 'mc', question: 'What event occurred on the Dark Day prophesied as a sign?', options: ['May 19, 1755', 'May 19, 1780', 'November 13, 1833', 'October 22, 1844'], answer: 1 },
        { id: 8, type: 'tf', question: 'Footwashing is an optional tradition that is not considered an ordinance.', answer: false },
        { id: 9, type: 'mc', question: 'What does Amos 3:7 say God reveals to His prophets?', options: ['The future', 'His secrets', 'Hidden treasures', 'Scientific knowledge'], answer: 1 },
        { id: 10, type: 'tf', question: 'The communion elements represent the unleavened bread and unfermented wine.', answer: true },
    ],
    // Exam Sample 4
    [
        { id: 1, type: 'tf', question: 'The Trinity consists of three separate Gods working together.', answer: false },
        { id: 2, type: 'mc', question: 'What commandment begins with the word "Remember"?', options: ['Third', 'Fourth', 'Fifth', 'Sixth'], answer: 1 },
        { id: 3, type: 'tf', question: 'Sanctification is an instantaneous event that happens at conversion.', answer: false },
        { id: 4, type: 'mc', question: 'According to Hebrews 4:12, what is the Word of God compared to?', options: ['A lamp', 'A two-edged sword', 'Living water', 'A rock'], answer: 1 },
        { id: 5, type: 'tf', question: 'The 70-week prophecy in Daniel 9:24-27 points to Christ\'s ministry and crucifixion.', answer: true },
        { id: 6, type: 'mc', question: 'In what year did Christ die on the cross?', options: ['27 AD', '31 AD', '34 AD', '70 AD'], answer: 1 },
        { id: 7, type: 'tf', question: 'The state of the dead is described in the Bible as an unconscious sleep.', answer: true },
        { id: 8, type: 'mc', question: 'What fell from heaven in 1833 as a prophetic sign?', options: ['Fire', 'Meteors', 'Angels', 'Rain'], answer: 1 },
        { id: 9, type: 'tf', question: 'According to Romans 6:3-4, baptism symbolizes death, burial, and resurrection.', answer: true },
        { id: 10, type: 'mc', question: 'Which of the following is NOT one of God\'s attributes?', options: ['Eternal', 'Limited', 'Omniscient', 'Omnipotent'], answer: 1 },
    ],
];

export const bibleTruthsSections = [
    {
        id: 'exam-prep',
        title: '📖 Master Guide Bible Truth Exam - Key Verses (KJV)',
        lessons: [
            {
                id: 'exam-god-creation',
                title: 'God & Creation',
                content: `
Genesis 1:1-2
"In the beginning God created the heaven and the earth. And the earth was without form, and void; and darkness was upon the face of the deep. And the Spirit of God moved upon the face of the waters."

Genesis 2:1-3
"Thus the heavens and the earth were finished, and all the host of them. And on the seventh day God ended his work which he had made; and he rested on the seventh day from all his work which he had made. And God blessed the seventh day, and sanctified it: because that in it he had rested from all his work which God created and made."

John 1:1-3
"In the beginning was the Word, and the Word was with God, and the Word was God. The same was in the beginning with God. All things were made by him; and without him was not any thing made that was made."

Colossians 1:16-17
"For by him were all things created, that are in heaven, and that are in earth, visible and invisible, whether they be thrones, or dominions, or principalities, or powers: all things were created by him, and for him: And he is before all things, and by him all things consist."
    `
            },
            {
                id: 'exam-salvation',
                title: 'The Plan of Salvation',
                content: `
Romans 3:23-25
"For all have sinned, and come short of the glory of God; Being justified freely by his grace through the redemption that is in Christ Jesus: Whom God hath set forth to be a propitiation through faith in his blood, to declare his righteousness for the remission of sins that are past, through the forbearance of God;"

Romans 5:1-2
"Therefore being justified by faith, we have peace with God through our Lord Jesus Christ: By whom also we have access by faith into this grace wherein we stand, and rejoice in hope of the glory of God."

Romans 5:8-10
"But God commendeth his love toward us, in that, while we were yet sinners, Christ died for us. Much more then, being now justified by his blood, we shall be saved from wrath through him."

1 Timothy 2:5
"For there is one God, and one mediator between God and men, the man Christ Jesus;"

John 3:16
"For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    `
            },
            {
                id: 'exam-sabbath',
                title: 'The Sabbath',
                content: `
Exodus 20:8-11
"Remember the sabbath day, to keep it holy. Six days shalt thou labour, and do all thy work: But the seventh day is the sabbath of the LORD thy God: in it thou shalt not do any work, thou, nor thy son, nor thy daughter, thy manservant, nor thy maidservant, nor thy cattle, nor thy stranger that is within thy gates: For in six days the LORD made heaven and earth, the sea, and all that in them is, and rested the seventh day: wherefore the LORD blessed the sabbath day, and hallowed it."

Ezekiel 20:12
"Moreover also I gave them my sabbaths, to be a sign between me and them, that they might know that I am the LORD that sanctify them."

Isaiah 66:22-23
"For as the new heavens and the new earth, which I will make, shall remain before me, saith the LORD, so shall your seed and your name remain. And it shall come to pass, that from one new moon to another, and from one sabbath to another, shall all flesh come to worship before me, saith the LORD."
    `
            },
            {
                id: 'exam-death',
                title: 'State of the Dead',
                content: `
Ecclesiastes 9:5-6
"For the living know that they shall die: but the dead know not any thing, neither have they any more a reward; for the memory of them is forgotten. Also their love, and their hatred, and their envy, is now perished; neither have they any more a portion for ever in any thing that is done under the sun."

John 11:11-14
"These things said he: and after that he saith unto them, Our friend Lazarus sleepeth; but I go, that I may awake him out of sleep. Then said his disciples, Lord, if he sleep, he shall do well. Howbeit Jesus spake of his death: but they thought that he had spoken of taking of rest in sleep. Then said Jesus unto them plainly, Lazarus is dead."

1 Thessalonians 4:16-17
"For the Lord himself shall descend from heaven with a shout, with the voice of the archangel, and with the trump of God: and the dead in Christ shall rise first: Then we which are alive and remain shall be caught up together with them in the clouds, to meet the Lord in the air: and so shall we ever be with the Lord."
    `
            },
            {
                id: 'exam-sanctuary',
                title: 'The Sanctuary',
                content: `
Hebrews 8:1-2
"Now of the things which we have spoken this is the sum: We have such an high priest, who is set on the right hand of the throne of the Majesty in the heavens; A minister of the sanctuary, and of the true tabernacle, which the Lord pitched, and not man."

Hebrews 9:11-12
"But Christ being come an high priest of good things to come, by a greater and more perfect tabernacle, not made with hands, that is to say, not of this building; Neither by the blood of goats and calves, but by his own blood he entered in once into the holy place, having obtained eternal redemption for us."

Daniel 8:14
"And he said unto me, Unto two thousand and three hundred days; then shall the sanctuary be cleansed."

Leviticus 16:29-30
"And this shall be a statute for ever unto you: that in the seventh month, on the tenth day of the month, ye shall afflict your souls, and do no work at all... For on that day shall the priest make an atonement for you, to cleanse you, that ye may be clean from all your sins before the LORD."
    `
            },
            {
                id: 'exam-second-coming',
                title: 'The Second Coming',
                content: `
Acts 1:11
"Which also said, Ye men of Galilee, why stand ye gazing up into heaven? this same Jesus, which is taken up from you into heaven, shall so come in like manner as ye have seen him go into heaven."

Matthew 24:27
"For as the lightning cometh out of the east, and shineth even unto the west; so shall also the coming of the Son of man be."

Matthew 24:30-31
"And then shall appear the sign of the Son of man in heaven: and then shall all the tribes of the earth mourn, and they shall see the Son of man coming in the clouds of heaven with power and great glory. And he shall send his angels with a great sound of a trumpet, and they shall gather together his elect from the four winds, from one end of heaven to the other."
    `
            },
            {
                id: 'exam-spiritual-gifts',
                title: 'Spiritual Gifts',
                content: `
1 Corinthians 12:4-7
"Now there are diversities of gifts, but the same Spirit. And there are differences of administrations, but the same Lord. And there are diversities of operations, but it is the same God which worketh all in all. But the manifestation of the Spirit is given to every man to profit withal."

Revelation 12:17
"And the dragon was wroth with the woman, and went to make war with the remnant of her seed, which keep the commandments of God, and have the testimony of Jesus Christ."

Amos 3:7
"Surely the Lord GOD will do nothing, but he revealeth his secret unto his servants the prophets."
    `
            },
            {
                id: 'exam-ordinances',
                title: 'Ordinances (Baptism, Communion, Footwashing)',
                content: `
Romans 6:3-4 (Baptism)
"Know ye not, that so many of us as were baptized into Jesus Christ were baptized into his death? Therefore we are buried with him by baptism into death: that like as Christ was raised up from the dead by the glory of the Father, even so we also should walk in newness of life."

1 Corinthians 11:23-26 (Communion)
"For I have received of the Lord that which also I delivered unto you, That the Lord Jesus the same night in which he was betrayed took bread: And when he had given thanks, he brake it, and said, Take, eat: this is my body, which is broken for you: this do in remembrance of me. After the same manner also he took the cup, when he had supped, saying, This cup is the new testament in my blood: this do ye, as oft as ye drink it, in remembrance of me. For as often as ye eat this bread, and drink this cup, ye do shew the Lord's death till he come."

John 13:14-15 (Footwashing)
"If I then, your Lord and Master, have washed your feet; ye also ought to wash one another's feet. For I have given you an example, that ye should do as I have done to you."
    `
            },
            {
                id: 'exam-prophecy',
                title: 'Prophecy & Church Heritage',
                content: `
Daniel 9:24-25 (70 Weeks Prophecy)
"Seventy weeks are determined upon thy people and upon thy holy city, to finish the transgression, and to make an end of sins, and to make reconciliation for iniquity... Know therefore and understand, that from the going forth of the commandment to restore and to build Jerusalem unto the Messiah the Prince shall be seven weeks, and threescore and two weeks..."

Revelation 14:6-12 (Three Angels' Messages)
"And I saw another angel fly in the midst of heaven, having the everlasting gospel to preach unto them that dwell on the earth, and to every nation, and kindred, and tongue, and people, Saying with a loud voice, Fear God, and give glory to him; for the hour of his judgment is come: and worship him that made heaven, and earth, and the sea, and the fountains of waters. And there followed another angel, saying, Babylon is fallen, is fallen... And the third angel followed them, saying with a loud voice, If any man worship the beast and his image, and receive his mark in his forehead, or in his hand... Here is the patience of the saints: here are they that keep the commandments of God, and the faith of Jesus."
    `
            },
            {
                id: 'exam-key-dates',
                title: '📅 Key Dates & Study Tips',
                content: `
IMPORTANT DATES TO MEMORIZE:
• 538 AD - Start of 1260-year prophecy (papal supremacy begins)
• 1798 AD - End of 1260-year prophecy (Pope taken prisoner)
• 1844 AD - End of 2300-day prophecy (Investigative Judgment begins)
• 27 AD - Jesus baptized and anointed as Messiah
• 31 AD - Jesus crucified (midst of 70th week)
• 34 AD - End of 70-week prophecy (Stephen stoned, gospel to Gentiles)
• 70 AD - Destruction of Jerusalem

EXAM SUCCESS TIPS:
✓ Memorize book-chapter-verse references exactly
✓ Know the context of each verse (what comes before/after)
✓ Be able to explain each doctrine using 2-3 key verses
✓ Study the 28 Fundamental Beliefs systematically
✓ Practice multiple choice questions about:
  - Christ as the only mediator (1 Timothy 2:5)
  - The scapegoat representing Satan
    `
            },
        ]
    }
];
